// extracted by mini-css-extract-plugin
export var menu = "styles-module--menu--DZcF-";
export var items = "styles-module--items--1esfB";
export var active = "styles-module--active--2PHRu";
export var overlay = "styles-module--overlay--1Epak";
export var container = "styles-module--container--2YD9J";
export var logo = "styles-module--logo--3S9ke";
export var itemsContainer = "styles-module--itemsContainer--1vb04";
export var link = "styles-module--link--2HJoT";
export var socialWrapper = "styles-module--socialWrapper--1vCow";